<template>
<div>
  <!--prmanent-emp ref="prementEmp" refId="prementEmp" title="상주직원 정보 입력" :items="modalItems"/>
  <out-info ref="outInfo" refId="outInfo" title="퇴실정보입력" :items="modalItems"/>
  <enter-info ref="enterInfo" title="입실정보입력" :items="modalItems" :key="uniqueKey"/-->
  <page-header title="예약자 조회" description="예약자를 조회할 수 있습니다.">
  </page-header>
  <div class="page-body ph-30 book-search">
    <div class="pt-20 pb-20">
      <div class="row">
        <div class="search-item">
            <div class="input-group">
              <span class="input-group-addon title">기간선택</span>
              <DatePicker class="form-control"
                          type="date"
                          range
                          :append-to-body="false"
                          :popup-style="{ left: 0}"
                          v-model="dateRange"
                          style="width:220px; font-size: 12px;"
                          :clearable="false"
                          :editable="false"
                          input-class="calendar-input">
                <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
              </DatePicker>
          </div>
        </div>

        <div class="search-item">
          <div class="input-group">
            <dropdown title="상태" v-model="searchItem.statusCode" :datasource="statusDropList" :isSelectionFirstData="searchItem.statusCode == null ? true :false"/>
          </div>
        </div>

        <div class="search-item">
          <div class="input-group">
            <dropdown v-model="searchItem.isLong" :datasource="termList" title="장/단기" :isSelectionFirstData="searchItem.isLong == null ? true :false" inline="inline"/>
          </div>
        </div>
        <div class="search-item">
          <div class="input-group">
            <dropdown v-model="searchItem.isSecure" :datasource="zoneList" title="존" :isSelectionFirstData="searchItem.isSecure == null ? true :false" inline="inline"/>
          </div>
        </div>

      </div>



      <div class="row">
        <div class="search-item">
            <div class="input-group">
              <span class="input-group-addon title">티켓번호</span>
              <input v-model="searchItem.ntreeTicket" type="text" class="form-control" placeholder="NTREE티켓번호를 입력하세요.">
          </div>
        </div>

        <div class="search-item">
          <div class="input-group">
            <span class="input-group-addon title">이름</span>
            <input v-model="searchItem.visitorName"  type="text" class="form-control" placeholder="출입자이름을 입력하세요.">
          </div>
        </div>

        <div class="search-item">
          <div class="input-group">
              <span class="input-group-addon title">차량번호</span>
              <input v-model="searchItem.carNumber" type="text" class="form-control" placeholder="차량번호를 입력하세요.">
          </div>
        </div>
        <div class="search-item">
          <div class="input-group">
            <span class="input-group-addon title">회사명</span>
              <input v-model="searchItem.visitorCompany" type="text" class="form-control" placeholder="회사명을 입력하세요.">
          </div>
        </div>
        <div class="search-item">
          <button class="btn btn-md line-1" @click="resetSearchItem()">Reset</button>
        </div>
        <div class="search-item">
          <button class="btn btn-md blue ml-6" @click="searchClick()">검색</button>
        </div>
        <div class="search-item" style="margin-left:auto">
          <button class="btn btn-lg line-2" @click="downloadExcel()"  title="현재 조회된 발송 목록 결과를 다운로드 가능한 Excel 파일로 생성 요청하거나, 파일 생성 요청 목록을 확인한 후 파일을 다운로드할 수 있습니다." data-toggle="tooltip" data-placement="right"><i class="icon-excel mr-5 font-size-11"></i>다운로드 요청 / 목록</button>
        </div>
      </div>
    </div>



    <data-table :datasource="items" :noDataSpan="10">
      <template v-slot:header>
        <data-table-header-column name="checked" displayName="" width="50px">
          <label class="md-check">
            <input type="checkbox" @change="check" v-model="checkedAll">
            <i class="blue"></i>
          </label>
        </data-table-header-column>
        <data-table-header-column name="ntreeTicket" displayName="티켓번호" width="15%"/>
        <data-table-header-column name="visitorName" displayName="이름" width="10%"/>
        <data-table-header-column name="visitorCompany" displayName="회사명" width="15%"/>
        <data-table-header-column name="statusCode" displayName="출입기간" width="10%"/>
        <data-table-header-column name="empName" displayName="담당자" width="10%"/>
        <data-table-header-column name="assetList" displayName="반입자산" />
        <data-table-header-column name="fromDate" displayName="차량정보" width="10%"/>
        <data-table-header-column name="toDate" displayName="상태" width="10%"/>
        <data-table-header-column name="more" displayName="" width="50px"/>
      </template>
       <!--td>{{item.ntreeTicket}}</td>
            <td>{{item.visitorName}}</td>
            <td>{{item.visitorCompany}}</td>
            <td>{{getDueDate(item.fromDate, item.toDate)}}</td>
            <td>{{item.empName}}</td>
            <td>{{getAssetNames(item.visitorAssets)}}</td>
            <td>{{item.carNumber}}</td>
            <td><i :class="['dot', getStatus(item)]"></i> {{statusDropList[item.statusCode].name}}</td-->
      <template v-if="total != 0" v-for="(item, $index) in items">
        <tr v-bind:key="$index" :class="[selectedIndex == item.uuid ? 'expanded' : null]">
          <data-table-column name="checked" displayName="" width="50px">
            <label class="md-check">
              <input type="checkbox" v-model="item.checked" @change="checkboxChange">
              <i class="blue"></i>
            </label>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <!--<a :href="`http://ntree.navercorp.com/staff/ticket/popup/${item.ntreeTicket}.html`">-->
              <span class="td-text ellipsis" data-original-title="티켓번호" :style="item.ntreeTicket && item.statusCode > 1? 'cursor:pointer;color:#187ed6;' : ''" @click="goNtreeTicket(item.ntreeTicket)">
                {{item.ntreeTicket == null ? item.reservationType : item.statusCode > 1 ? item.ntreeTicket : ''}}
                <i v-if="item.ntreeTicket && item.statusCode > 1" class="icon-move-link"></i>
              </span>
            <!--</a>-->
          </data-table-column>
          <data-table-column name="checked" displayName="" >
            <span class="td-text ellipsis" data-original-title="이름">{{item.visitorName}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="회사명">{{item.visitorCompany}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="출입기간">{{getDueDate(item.fromDate, item.toDate)}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="담당자">{{item.empName}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="반입자산">{{getAssetNames(item.assetList)}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="차량정보">{{item.checkInTimestamp ? getDate(item.checkInTimestamp) : null}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="상태"><i :class="['dot', getStatus(item)]"></i> {{getCodeByKey('visitStatus', 'statusCode', item.statusCode).statusStr}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <a @click="itemClick(item)">
              <i :class="['icon', selectedIndex == item.uuid ? 'icon-arrow-line-up' : 'icon-arrow-line-down']"></i>
            </a>
          </data-table-column>
        </tr>

        <BookForm :item="item" v-bind:key="'detail-'+$index" v-if="selectedIndex == item.uuid"/>
      </template>
    </data-table>
    <Pagenation ref="paging" :datasource="resultData" @pageChange="pageChange"/>
  </div>

</div>
</template>

<script>
import PageHeader from '@/layout/PageHeader.vue';
import DataTableBase from '@/components/common/dataTableBase';
import DataTable from '@/components/common/DataTable.vue';
import DataTableHeaderColumn from '@/components/common/DataTableHeaderColumn.vue';
import DataTableColumn from '@/components/common/DataTableColumn.vue';
import Pagenation from '@/components/common/Pagenation';
import Dropdown from '@/components/Dropdown.vue';
import BookForm from './BookForm.vue';

import EnterInfo from './EnterInfo.vue';
import OutInfo from './OutInfo.vue';
import PrmanentEmp from './PrmanentEmp.vue';

export default {
  mixins: [DataTableBase],
  components:{
    Pagenation,
    PageHeader,
    DataTable,
    DataTableHeaderColumn,
    DataTableColumn,
    Dropdown,
    BookForm,
    EnterInfo, OutInfo, PrmanentEmp,

  },
  data(){

    return {
      EnterInfo:EnterInfo,
      uniqueKey: null,
      modalItems: [],
      selectedItems: null,
      isCheckedAll: false,
      statusDropList: [{name: '전체', value: null, isChecked: true}, {name: '입실대기', value: 5}, {name: '입실', value: 6}, {name: '퇴실', value: 7}, {name: '카드 미반납', value: 8}],
      typeDropList: [{name: '전체', value: null, isChecked: true}, {name: 'VMS', value: 'VMS'}, {name: 'NTREE', value: 'NTREE'}, {name: 'AB등급', value: 'AB'}, {name: '상주직원', value: 'RESIDENT'}],
      searchTypeItem: {},
      statusDropList: [{name: '전체', value: null, isChecked: true}, {name: '담당임직원 승인대기', value: 1}, {name: '내부결재 진행중', value: 2}, {name: '승인완료', value: 3}, {name: '승인거절', value: 4}, {name: '입/퇴실완료', value: 5}],
      zoneList: [{name: '전체', value: null, isChecked: true}, {name: '일반존', value: '0', isChecked: true}, {name: '공공금융존', value: 1}],
      termList: [{name: '전체', value: null, isChecked: true}, {name: '장기출입자', value: '1', isChecked: true}, {name: '단기출입자', value: '0'}],

      getApi:'visitor/reservationSearch',
      paging: this.$dataProvider.paging,
      boardSearchDataSource: this.$dataProvider.boardSearchDataSource,
      searchItem: {
        ntreeTicket: null,
        carNumber: null,
        visitorName: null,
        visitorCompany: null,
        isSecure: null,
        isLong: null,
        statusCode: null,
      },
      dateRange: null,
      total: 0,
      resultData : null,
      //rowItem : {title: '공지사항', user: '강선호', createDate: '2021-07-07', modifiedDate: '2021-07-07'},
      //items: []
    }
  },
  computed: {
    getStatus(){
      /*
      1,2번 노랑 요청, 승인대기
      3번 승인완료 초록
      4번 승인 거절 빨강
      5번 입퇴실 완료 회색
      */
      return (item) => {
        var color = 'grey'
        if(item.statusCode == 1 || item.statusCode == 2)
          color = 'yellow';
        if(item.statusCode == 3)
          color = 'green';
        if(item.statusCode == 4)
          color = 'red';
        return color;
      }
    },
    getAssetNames() {
      return (assets) => {
        return _.map(assets, x => x.visitorAssetCode.assetStr).join(', ')
        //return assets
      }
    },
    getCheckedItem() {
      return (items) => {
        var result = '전체';
        var o = _.find(items, {isChecked:true})
        if(o && o.name){
          result = o.name;
        }
        return result;
      }
    },
    async getIdc(){
      var result = [];
      if(await this.$store.getters['location/location']){
        var list = await this.$store.getters['location/location'];
        result.push({value: null, name: '전체', checked:true})
        list.forEach((x) => {
          var o = {value: x.locationCode, name : x.locationName}
          result.push(o)
        })
      }
      return result;
    },
    currentIdc(){
      return this.$store.state.location.currentIdc;
    }
  },
  watch: {
    currentIdc(nVal, oVal){
      this.init();
    }
  },
  mounted(){
    this.init();
  },
  methods: {
    init(){
      let query = Object.assign({},this.$route.query);
      this.searchItem = query;
      if(!this.searchItem.fromDate) this.searchItem.fromDate = Date.now();
      if(!this.searchItem.toDate) this.searchItem.toDate = Date.now();
      this.dateRange = [moment(Number(this.searchItem.fromDate)).toDate(), moment(Number(this.searchItem.toDate)).toDate()];

      if(!query.limit || !query.offset){
        Object.entries(this.paging).forEach((data) => {
          query[data[0]] = data[1];
        });
      }
      query.visitIdcCode = this.currentIdc.locationCode;

      this.$router.push({query: query}).then(() => {
        this.findAll();
      }).catch((e) => {
        this.findAll();
      });

    },
    pageChange(event){

      if(event) this.paging = event.data;
      let query = Object.assign({},this.$route.query);
      // this.searchTypeList.forEach((x) => {delete query[x.value]})
      query.limit = this.paging.limit;
      query.offset = this.paging.offset;
      this.$router.push({ path: this.$route.path, query: query});
      this.findAll();

    },
    itemClick(item){
      if(this.selectedIndex != item.uuid)
        this.selectedIndex = item.uuid;
      else
       this.selectedIndex = null;
    },
    searchSetting(){
      var query = Object.assign({},this.$route.query);

      delete query.ntreeTicket;
      delete query.carNumber;
      delete query.visitorName;
      delete query.toDate;
      delete query.fromDate;
      delete query.isLong;
      delete query.statusCode;
      delete query.isSecure;
      if(this.dateRange){
        this.searchItem.fromDate = moment(this.dateRange[0]).valueOf();
        this.searchItem.toDate = moment(this.dateRange[1]).valueOf();
      }

      query = Object.assign(query, this.copyNew(this.searchItem));
      Object.keys(query).forEach(x => {
        if(query[x] == '' || query[x] == null)
          delete query[x]
      })
      return query;
    },
    searchClick(){
      var query = this.searchSetting();

      query.offset = 1;
      this.$router.push({query: query}).then(() => {
        this.findAll();
      }).catch(() => {
        this.findAll();
      })

    },
    downloadExcel(){
      var query = this.searchSetting();
      this.$http.get('/api/private/visitor/reservationSearch/download', {params: query, responseType: 'blob'},)
        .then(function(result) {
          const url = window.URL.createObjectURL(new Blob([result.data], {type: 'application/octet-stream'}));
          const link = document.createElement('a');
          link.href = url;

          let fileName = this.currentIdc.locationName + " "+ this.getDueDateFormat(this.searchItem.fromDate, this.searchItem.toDate, 'YYYYMMDD', '_') +' 예약자목록.xlsx';
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }.bind(this)).catch((e) =>{
      })
    },
    resetSearchItem(){
      var that = this;
      Object.keys(this.searchItem).forEach(x => {
        that.searchItem[x] = null;
      })
      this.$router.go(0);
    },
    goNtreeTicket(ticketNumber) {
      if(ticketNumber) {
        let url = `http://ntree.navercorp.com/staff/ticket/popup/${ticketNumber}.html`;
        window.open(url);
      }

    },
  }
}
</script>
